__webpack_require__.p = "/sellers/";